import * as React from "react";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import { SessionSelectionDialog } from "../components/SessionSelectionDialog";
import { ErrorBoundary } from "../components/ErrorBoundary";

const SessionDialog: React.FC = () => {
  React.useEffect(() => {
    // Office.js dialog logic
    Office.onReady(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const action = urlParams.get("action");
      if (action === "selectSession") {
        // No-op: rendering handled by React below
      }
    });
  }, []);

  const handleSessionSelected = (sessionId: string, sessionName: string) => {
    try {
      Office.context.ui.messageParent(
        JSON.stringify({
          action: "selectSession",
          sessionId,
          sessionName,
        })
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error sending selection message:", error);
    }
  };

  const handleCancel = () => {
    try {
      Office.context.ui.messageParent(
        JSON.stringify({
          action: "cancelSelection",
        })
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error sending cancel message:", error);
    }
  };

  return (
    <ErrorBoundary>
      <FluentProvider theme={teamsLightTheme}>
        <SessionSelectionDialog onSessionSelected={handleSessionSelected} onCancel={handleCancel} />
      </FluentProvider>
    </ErrorBoundary>
  );
};

export default SessionDialog;
